import React from "react";

const SLICES = [
  { label: "retards (you)", value: 100, color: "#E8742C" },
  { label: "team", value: 0, color: "#457B9D" },
  { label: "roadmap", value: 0, color: "#2A9D8F" },
  { label: "vc snakes 🐍", value: 0, color: "#E63946" },
];

export const Tokenomics = () => {
  return (
    <section className="px-5 md:px-10 py-14" data-testid="tokenomics-section">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-display text-5xl md:text-7xl">
            <span className="scribble-underline">retardonomics</span>
          </h2>
          <p className="text-lg md:text-xl text-[#1A1A1A]/70 mt-2">
            our accountant is a 4 year old with a crayon. checks out.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-10 items-center">
          {/* doodle pie */}
          <div className="flex justify-center">
            <svg
              viewBox="0 0 200 200"
              className="w-72 h-72 md:w-96 md:h-96 float-y"
              role="img"
              aria-label="100 percent retard pie chart"
            >
              <circle
                cx="100"
                cy="100"
                r="90"
                fill="#E8742C"
                stroke="#1A1A1A"
                strokeWidth="6"
                strokeDasharray="3 6"
              />
              <text
                x="100"
                y="92"
                textAnchor="middle"
                fontFamily="Caveat Brush, cursive"
                fontSize="40"
                fill="#FFFFFF"
                stroke="#1A1A1A"
                strokeWidth="1.5"
              >
                100%
              </text>
              <text
                x="100"
                y="128"
                textAnchor="middle"
                fontFamily="Caveat Brush, cursive"
                fontSize="22"
                fill="#FFFFFF"
                stroke="#1A1A1A"
                strokeWidth="1"
              >
                retarded
              </text>
            </svg>
          </div>

          <div className="space-y-4">
            {SLICES.map((s, idx) => (
              <div
                key={s.label}
                className="crayon-card-soft flex items-center justify-between px-5 py-4"
                style={{ transform: `rotate(${idx % 2 ? 1.2 : -1.2}deg)` }}
                data-testid={`tokenomics-slice-${idx}`}
              >
                <div className="flex items-center gap-3">
                  <span
                    className="inline-block w-6 h-6 rounded-full border-2 border-[#1A1A1A]"
                    style={{ background: s.color }}
                  />
                  <span className="font-display text-2xl md:text-3xl">{s.label}</span>
                </div>
                <span className="font-display text-3xl md:text-4xl text-[#E8742C]">
                  {s.value}%
                </span>
              </div>
            ))}
            <div className="text-center md:text-left font-display text-2xl text-[#1A1A1A]/80 pt-2">
              ✦ supply: 1,000,000,000 ✦ LP: burnt 🔥 ✦ taxes: 0% ✦
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Tokenomics;
